import { ValueOfObject } from 'shared/utils/types';

export const RaListOrder = Object.freeze({
  ASC: 'ASC',
  DESC: 'DESC'
} as const);
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RaListOrder = ValueOfObject<typeof RaListOrder>;
